// Walkitt behaviour. No libraries. Offer values live in CONFIG; on Shopify they come from the product variants.
(function () {
  var CONFIG = {
    // Black Weeks runs through Cyber Monday. Regular price is $49 a pair; was = regular price x pairs.
    regular: 49,
    offerEnds: "2026-11-30T23:59:00-05:00",
    bundles: {
      1: { name: "1 pair", label: "Save 50%", price: 24.5, was: 49 },
      2: { name: "2 pairs", label: "Save 60%", price: 39.2, was: 98 },
      3: { name: "3 pairs", label: "Save 70%", price: 44.1, was: 147 },
      5: { name: "3 + 2 pairs", label: "5 pairs, save 82%", price: 44.1, was: 245 },
    },
  };
  // Inside the Shopify theme, WK_SHOP holds the asset base and size -> variant ids. On localhost the cart stays a preview.
  var SHOP = window.WK_SHOP || null;
  function asset(name) { return (SHOP ? SHOP.asset : "assets/img/") + name; }
  // Theme settings fill WK_TEXT, so every message below can be changed in the Shopify editor.
  function T(key, fallback) { var t = window.WK_TEXT; return t && t[key] != null && t[key] !== "" ? t[key] : fallback; }
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  // keep "12-Hour" on one line in headings, whatever the headline is edited to
  $$(".h1,.h2").forEach(function (h) { h.innerHTML = h.innerHTML.replace(/(\d+-Hour)/g, '<span class="nw">$1</span>'); });

  // reveal + rings
  var targets = $$("[data-r],[data-rings]");
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("on"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.05 });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add("on"); });
  }

  // gallery: native scroll-snap, arrows and thumbs drive it
  $$("[data-gal]").forEach(function (g) {
    var main = $(".gal__main", g);
    // a photo hidden in the editor leaves an empty slide and thumb, which are skipped here
    var has = function (el) { return el.children.length > 0; };
    var slides = $$("figure", main).filter(has), thumbs = $$(".gal__thumbs button", g).filter(has);
    var idx = 0;
    function mark(i) {
      idx = i;
      thumbs.forEach(function (t, n) {
        t.setAttribute("aria-current", n === i ? "true" : "false");
        if (n === i && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.parentNode.scrollLeft = t.offsetLeft - t.parentNode.offsetLeft - 40;
      });
    }
    function go(i) {
      i = (i + slides.length) % slides.length;
      main.scrollTo({ left: slides[i].offsetLeft - main.offsetLeft, behavior: "smooth" });
      mark(i);
    }
    thumbs.forEach(function (t, n) { t.addEventListener("click", function () { go(n); }); });
    var l = $(".gal__arrow--l", g), r = $(".gal__arrow--r", g);
    if (l) l.addEventListener("click", function () { go(idx - 1); });
    if (r) r.addEventListener("click", function () { go(idx + 1); });
    var tick;
    main.addEventListener("scroll", function () {
      clearTimeout(tick);
      tick = setTimeout(function () { mark(Math.round(main.scrollLeft / main.clientWidth)); }, 90);
    }, { passive: true });
    mark(0);
  });

  // bundle + price
  var state = { bundle: 2, size: "", count: 0, mixed: false, sizes: [] };
  function money(n) { return "$" + (n % 1 ? n.toFixed(2) : n); }
  function paintPrice() {
    var b = CONFIG.bundles[state.bundle], inp = $("input[name=bundle]:checked");
    var now = (inp && inp.getAttribute("data-now")) || money(b.price), was = (inp && inp.getAttribute("data-was")) || (b.was ? money(b.was) : "");
    $$("[data-price]").forEach(function (el) {
      el.innerHTML = now + (was ? " <s>" + was + "</s>" : "");
    });
  }
  // sizes: one size for every pair, or a size per pair once the buyer opens "mix"
  var SIZES = {};
  $$("input[name=size]").forEach(function (i) {
    var b = i.nextElementSibling.querySelector("b,strong"), all = i.nextElementSibling.textContent.trim();
    SIZES[i.value] = b ? b.textContent + " (" + all.replace(b.textContent, "").trim() + ")" : all;
    if (i.checked) state.size = i.value;
  });
  function shortSize(v) { return v.replace(/ \| UK [^|]+\|/, " |"); }
  var mixBox = $("[data-mix]"), mixRows = $("[data-mix-rows]"), mixBtn = $("[data-mix-toggle]"), sizeGrid = $(".size__g");
  function pairSizes() {
    var out = [];
    for (var n = 0; n < state.bundle; n++) out.push(state.mixed && state.sizes[n] ? state.sizes[n] : state.size);
    return out;
  }
  function sizeLabel() {
    var list = pairSizes(), one = list.every(function (s) { return s === list[0]; });
    return one ? "Size " + shortSize(list[0]) : "Sizes " + list.map(shortSize).join(", ");
  }
  function paintMix() {
    if (!mixBox) return;
    if (state.bundle === 1) state.mixed = false;
    mixBox.hidden = state.bundle === 1;
    sizeGrid.hidden = state.mixed;
    mixRows.hidden = !state.mixed;
    mixBtn.textContent = state.mixed ? T("mix_close", "Use one size for all pairs") : T("mix_open", "Different sizes? Mix them in this bundle");
    mixBtn.setAttribute("aria-expanded", state.mixed ? "true" : "false");
    if (!state.mixed) { mixRows.innerHTML = ""; return; }
    mixRows.innerHTML = pairSizes().map(function (cur, n) {
      var opts = Object.keys(SIZES).map(function (k) { return '<option value="' + k + '"' + (k === cur ? " selected" : "") + ">" + SIZES[k] + "</option>"; }).join("");
      return '<label class="mix__r"><span>' + T("pair_label", "Pair") + " " + (n + 1) + '</span><select data-mix-i="' + n + '">' + opts + "</select></label>";
    }).join("");
  }
  if (mixBox) {
    mixBtn.addEventListener("click", function () {
      state.mixed = !state.mixed;
      if (state.mixed) { state.sizes = []; for (var n = 0; n < 5; n++) state.sizes.push(state.size); }
      paintMix();
    });
    mixRows.addEventListener("change", function (e) {
      if (e.target.matches("select")) state.sizes[+e.target.getAttribute("data-mix-i")] = e.target.value;
    });
  }
  $$("input[name=bundle]").forEach(function (i) {
    i.addEventListener("change", function () { state.bundle = +i.value; paintPrice(); paintMix(); });
  });
  $$("input[name=size]").forEach(function (i) {
    i.addEventListener("change", function () { state.size = i.value; });
  });
  paintPrice();
  paintMix();

  // cart preview: one line, replaced on each add. Shopify's cart takes over when this is pushed.
  var drawer = $("#cart"), scrim = $("#scrim");
  function openCart() { drawer.classList.add("on"); scrim.classList.add("on"); document.body.style.overflow = "hidden"; $(".drawer__x", drawer).focus(); }
  function closeCart() { drawer.classList.remove("on"); scrim.classList.remove("on"); document.body.style.overflow = ""; }
  function setBadge(n) {
    var el = $("[data-cartn]");
    if (el) { el.textContent = n; el.hidden = !n; }
  }
  function paintPreviewCart() {
    var b = CONFIG.bundles[state.bundle], body = $(".drawer__b", drawer), foot = $(".drawer__f", drawer);
    if (!state.count) { body.innerHTML = "<p class=\"drawer__empty\">" + T("cart_empty", "Your cart is empty. One pair is all it takes to find out by clock-out.") + "</p>"; foot.hidden = true; return; }
    body.innerHTML = '<div class="line"><img src="' + asset("m-pair-grey-480.webp") + '" alt="" width="84" height="84"><div><b>Walkitt, ' + b.name + '</b><small>' + sizeLabel() + "<br>" + b.label + "</small></div><em>" + money(b.price) + "</em></div>";
    foot.hidden = false;
    $("[data-total]", drawer).textContent = money(b.price);
  }
  // Shopify cart: real lines, one per size, with the bundle discount Shopify applied
  function paintShopCart(cart) {
    var body = $(".drawer__b", drawer), foot = $(".drawer__f", drawer);
    var fmt = function (c) { return new Intl.NumberFormat("en-US", { style: "currency", currency: cart.currency }).format(c / 100); };
    setBadge(cart.item_count);
    if (!cart.item_count) { body.innerHTML = "<p class=\"drawer__empty\">" + T("cart_empty", "Your cart is empty. One pair is all it takes to find out by clock-out.") + "</p>"; foot.hidden = true; return; }
    body.innerHTML = cart.items.map(function (i) {
      return '<div class="line"><img src="' + i.image + '" alt="" width="84" height="84"><div><b>' + T("line_title", "Walkitt, size") + " " + shortSize(i.variant_title) + '</b><small>' + i.quantity + " " + (i.quantity === 1 ? T("pair_one", "pair") : T("pair_many", "pairs")) + '</small><button class="line__x" data-rm="' + i.key + '">' + T("remove", "Remove") + '</button></div><em>' + fmt(i.final_line_price) + "</em></div>";
    }).join("");
    foot.hidden = false;
    $("[data-total]", drawer).textContent = fmt(cart.total_price);
    var saved = $("[data-saved]", drawer), off = +T("regular", CONFIG.regular) * 100 * cart.item_count - cart.total_price; // same baseline as the bundle cards
    if (saved) { saved.textContent = off > 0 ? T("you_save", "You save") + " " + fmt(off) : ""; saved.hidden = off <= 0; }
  }
  function loadCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(paintShopCart); }
  function paintCart() { return SHOP ? loadCart() : paintPreviewCart(); }
  $$("[data-add]").forEach(function (btn) {
    btn.addEventListener("click", function (e) {
      if (!$("input[name=bundle]")) return; // homepage buttons are plain links to the product page
      e.preventDefault();
      if (!SHOP) {
        state.count = 1;
        paintCart();
        setBadge(1);
        openCart();
        return;
      }
      var byId = {};
      pairSizes().forEach(function (s) { byId[SHOP.variants[s]] = (byId[SHOP.variants[s]] || 0) + 1; });
      var items = Object.keys(byId).map(function (id) { return { id: +id, quantity: byId[id] }; });
      btn.disabled = true;
      fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return loadCart(); })
        .then(openCart)
        .catch(function () { $(".drawer__b", drawer).innerHTML = '<p class="drawer__empty">' + T("cart_error", "That did not go through. Please try again.") + "</p>"; $(".drawer__f", drawer).hidden = true; openCart(); })
        .then(function () { btn.disabled = false; });
    });
  });
  if (SHOP) {
    loadCart();
    drawer.addEventListener("click", function (e) {
      var key = e.target.getAttribute && e.target.getAttribute("data-rm");
      if (!key) return;
      fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: 0 }) })
        .then(function (r) { return r.json(); }).then(paintShopCart);
    });
  }
  $$("[data-cart-open]").forEach(function (b) { b.addEventListener("click", function () { paintCart(); openCart(); }); });
  $$("[data-cart-close]").forEach(function (b) { b.addEventListener("click", closeCart); });
  scrim.addEventListener("click", closeCart);
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeCart(); closeMenu(); } });

  // phone menu
  var mnav = $("#mnav");
  function closeMenu() { mnav.classList.remove("on"); }
  $$("[data-menu]").forEach(function (b) { b.addEventListener("click", function () { mnav.classList.add("on"); }); });
  $$("#mnav a, #mnav [data-menu-x]").forEach(function (a) { a.addEventListener("click", closeMenu); });

  // sticky add: shows once the main button has left the screen, hides again at the final offer
  var stick = $("#stick"), anchor = $("[data-stick-after]"), stop = $("[data-stick-stop]");
  if (stick && anchor) {
    var queued = false;
    var paint = function () {
      queued = false;
      var past = anchor.getBoundingClientRect().bottom < 0;
      var atStop = stop && stop.getBoundingClientRect().top < window.innerHeight;
      stick.classList.toggle("on", past && !atStop);
    };
    window.addEventListener("scroll", function () { if (!queued) { queued = true; requestAnimationFrame(paint); } }, { passive: true });
    paint();
  }

  // before/after slider: pointer drag on the whole image, range input for keyboards
  $$("[data-ba]").forEach(function (b) {
    var r = $(".ba__r", b), dragging = false, touched = false;
    function set(v) { v = Math.max(0, Math.min(100, v)); b.style.setProperty("--p", v + "%"); r.value = Math.round(v); }
    function at(e) { var x = b.getBoundingClientRect(); set(((e.clientX - x.left) / x.width) * 100); }
    b.addEventListener("pointerdown", function (e) { dragging = touched = true; b.setPointerCapture(e.pointerId); at(e); });
    b.addEventListener("pointermove", function (e) { if (dragging) at(e); });
    ["pointerup", "pointercancel"].forEach(function (t) { b.addEventListener(t, function () { dragging = false; }); });
    r.addEventListener("input", function () { touched = true; set(+r.value); });
    // one small nudge the first time it scrolls into view, so people see it moves
    if ("IntersectionObserver" in window && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      var seen = new IntersectionObserver(function (es) {
        if (!es[0].isIntersecting) return;
        seen.disconnect();
        var t0 = performance.now();
        (function step(t) {
          if (touched) return;
          var k = (t - t0) / 1500;
          if (k >= 1) { set(50); return; }
          set(50 + Math.sin(k * Math.PI * 2) * 16);
          requestAnimationFrame(step);
        })(t0);
      }, { threshold: 0.5 });
      seen.observe(b);
    }
  });

  // customer reviews and the rating line: every figure comes from the real reviews in [data-rv-json] (on Shopify: the
  // "Review" blocks). Samples show only in the theme editor and with ?reviews=preview, which is never linked from the site.
  var rvBox = $("[data-reviews]"), rvData = $("[data-rv-json]");
  if (rvBox && rvData) {
    var data = {};
    try { data = JSON.parse(rvData.textContent); } catch (err) { data = {}; }
    var real = (data.reviews || []).filter(function (v) { return v && v.text; });
    var preview = !real.length && (/[?&]reviews=preview/.test(location.search) || document.documentElement.hasAttribute("data-design"));
    var all = real.length ? real : preview ? (data.samples || []).filter(function (v) { return v && v.text; }).map(function (v) { var o = {}; for (var k in v) o[k] = v[k]; o.sample = true; return o; }) : [];
    all.forEach(function (v) {
      v.stars = Math.max(1, Math.min(5, +v.stars || 5));
      // samples carry "ago" (days) so their dates stay recent; real reviews carry a date
      var d = v.ago != null ? new Date(Date.now() - v.ago * 864e5) : v.date ? new Date(v.date + "T12:00:00") : null;
      v.when = d && !isNaN(d) ? d.getTime() : 0;
      v.dateText = v.when ? d.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }) : "";
      if (v.photo && !/[\/.]/.test(v.photo)) { v.thumb = asset(v.photo + "-480.webp"); v.full = asset(v.photo + "-1200.webp"); }
      else if (v.photo) { v.thumb = v.thumb || v.photo; v.full = v.photo; }
    });
    if (all.length) {
      var esc = function (s) { var d = document.createElement("div"); d.textContent = s == null ? "" : s; return d.innerHTML; };
      var five = new Array(6).join('<svg class="ic"><use href="#i-star"/></svg>');
      var stars = function (v) { return '<span class="stars" role="img" aria-label="' + v + ' out of 5"><span class="stars__b">' + five + '</span><span class="stars__f" style="width:' + (v / 5) * 100 + '%">' + five + "</span></span>"; };
      var total = all.length;
      var avg = all.reduce(function (n, v) { return n + v.stars; }, 0) / total;
      var word = avg >= 4.5 ? "Excellent " : avg >= 4 ? "Great " : "";
      var plural = total === 1 ? " review" : " reviews";
      $$("[data-rate]").forEach(function (r) {
        r.innerHTML = stars(avg) + "<span>" + word + avg.toFixed(1) + " | " + total.toLocaleString("en-US") + (total === 1 ? " Review" : " Reviews") + (preview ? " (sample)" : "") + "</span>";
        r.hidden = false;
      });
      $$("[data-assure]").forEach(function (x) { x.hidden = true; });
      $("[data-rv-sum]", rvBox).innerHTML = '<p class="rvh__avg">' + avg.toFixed(1) + '</p><p class="rvh__sl">' + stars(avg) + "<span>Based on " + total.toLocaleString("en-US") + plural + "</span></p>";
      $("[data-rv-bars]", rvBox).innerHTML = [5, 4, 3, 2, 1].map(function (n) {
        var c = all.filter(function (v) { return v.stars === n; }).length;
        return '<div class="rvb">' + stars(n) + '<span class="rvb__t"><span style="width:' + (c / total) * 100 + '%"></span></span><span class="rvb__c">' + c.toLocaleString("en-US") + "</span></div>";
      }).join("");
      $("[data-rv-count]", rvBox).textContent = total.toLocaleString("en-US") + plural;
      if (preview) $("[data-rv-banner]", rvBox).hidden = false;
      var listEl = $("[data-reviews-list]", rvBox), moreEl = $("[data-rv-more]", rvBox), sortEl = $("[data-rv-sort]", rvBox), limit = 6, rows = [];
      var body = function (v) {
        return '<div class="rvc__b"><div class="rvc__h"><span class="rvc__av" aria-hidden="true">' + esc((v.name || "?").charAt(0)) + '</span><div class="rvc__who"><p class="rvc__n">' + esc(v.name) + "</p>" +
          (v.verified ? '<p class="rvc__v"><svg class="ic"><use href="#i-check"/></svg>Verified Buyer</p>' : "") + "</div>" + (v.dateText ? '<time class="rvc__d">' + v.dateText + "</time>" : "") + "</div>" +
          stars(v.stars) + (v.title ? '<h3 class="rvc__ti">' + esc(v.title) + "</h3>" : "") + '<p class="rvc__t">' + esc(v.text) + "</p>" +
          (v.role || v.size ? '<p class="rvc__m">' + esc([v.role, v.size ? "Size " + v.size : ""].filter(Boolean).join(" · ")) + "</p>" : "") + "</div>";
      };
      var card = function (v, i) {
        return '<article class="rvc">' + (v.sample ? '<span class="rv__s">SAMPLE</span>' : "") +
          (v.thumb ? '<button class="rvc__i" type="button" data-rv-open="' + i + '" aria-label="Open the photo from ' + esc(v.name) + '"><img src="' + esc(v.thumb) + '" alt="Photo from ' + esc(v.name) + '" loading="lazy" width="480" height="640"></button>' : "") +
          body(v) + "</article>";
      };
      var paint = function () {
        var by = sortEl.value;
        rows = all.slice();
        if (by === "photo") rows = rows.filter(function (v) { return v.thumb; });
        rows.sort(function (x, y) { return by === "high" ? y.stars - x.stars || y.when - x.when : by === "low" ? x.stars - y.stars || y.when - x.when : y.when - x.when; });
        listEl.innerHTML = rows.slice(0, limit).map(card).join("");
        moreEl.hidden = rows.length <= limit;
      };
      // a photo opens the whole review, large
      var dlg = $("[data-rv-dialog]", rvBox);
      listEl.addEventListener("click", function (e) {
        var b = e.target.closest && e.target.closest("[data-rv-open]");
        if (!b || !dlg) return;
        var v = rows[+b.getAttribute("data-rv-open")];
        $("[data-rv-dialog-body]", dlg).innerHTML = '<img src="' + esc(v.full) + '" alt="Photo from ' + esc(v.name) + '">' + body(v);
        if (dlg.showModal) dlg.showModal(); else dlg.setAttribute("open", "");
      });
      if (dlg) {
        $("[data-rv-close]", dlg).addEventListener("click", function () { dlg.close ? dlg.close() : dlg.removeAttribute("open"); });
        dlg.addEventListener("click", function (e) { if (e.target === dlg && dlg.close) dlg.close(); });
      }
      sortEl.addEventListener("change", paint);
      moreEl.addEventListener("click", function () { limit += 6; paint(); });
      paint();
      rvBox.hidden = false;
    }
  }

  // compare tabs on phones
  var cmp = $("[data-cmp]");
  $$("[data-cmp-tab]").forEach(function (t) {
    t.addEventListener("click", function () {
      cmp.setAttribute("data-show", t.getAttribute("data-cmp-tab"));
      $$("[data-cmp-tab]").forEach(function (o) { o.setAttribute("aria-selected", o === t ? "true" : "false"); });
    });
  });

  // countdown to the real end of the offer; hides itself when it has passed
  var cd = $("[data-count]");
  if (cd) {
    var end = new Date(T("offer_ends", CONFIG.offerEnds)).getTime();
    var pad = function (n) { return (n < 10 ? "0" : "") + n; };
    var tickCd = function () {
      var s = Math.floor((end - Date.now()) / 1000);
      if (s <= 0) { cd.hidden = true; clearInterval(timer); return; }
      $("[data-d]", cd).textContent = Math.floor(s / 86400) + "d";
      $("[data-h]", cd).textContent = pad(Math.floor((s % 86400) / 3600)) + "h";
      $("[data-m]", cd).textContent = pad(Math.floor((s % 3600) / 60)) + "m";
      $("[data-s]", cd).textContent = pad(s % 60) + "s";
    };
    var timer = setInterval(tickCd, 1000);
    tickCd();
  }

  // Shopify's preview bar (only the owner sees it) covers the bottom of the screen: the sticky bar and the chat button
  // move up by its height while it's there
  (function () {
    var n = 0;
    var lift = function () {
      var bar = document.getElementById("PBarNextFrameWrapper"), r = bar && bar.getBoundingClientRect();
      var h = r && r.height && r.top < window.innerHeight ? Math.round(window.innerHeight - r.top) : 0;
      document.documentElement.style.setProperty("--pb", h + "px");
      if (++n < 40) setTimeout(lift, 750);
    };
    lift();
  })();

  // chat helper: the nurse in her round button is the button of Shopify Inbox's chat. Shopify's own round button stays in
  // the page, out of sight, for her to press; while its window is open she steps aside. The chat opens only when someone
  // presses her or her cloud (Jan, 2026-11-03: "don't open the chat automatically when i open the page"). Where Inbox isn't
  // there she leads to the contact page. Inbox's element names are not a documented interface (as found on ELEVEN's store,
  // 2026-10-13): if they change, Shopify's own button simply shows again.
  var nurse = $("#nurse");
  if (nurse) {
    var nBtn = $(".nurse__b", nurse), cloud = $("[data-nurse-cloud]", nurse), disc = $(".nurse__disc", nurse);
    var afterLoad = function (fn, ms) { var go = function () { setTimeout(fn, ms); }; if (document.readyState === "complete") go(); else window.addEventListener("load", go, { once: true }); };
    // the waving film, after the page has loaded; the still stays wherever a film can't play
    afterLoad(function () {
      if (navigator.connection && navigator.connection.saveData) return;
      var v = document.createElement("video");
      v.muted = true; v.loop = true; v.playsInline = true; v.setAttribute("playsinline", ""); v.setAttribute("aria-hidden", "true");
      v.addEventListener("playing", function () { nurse.classList.add("is-film"); });
      v.src = asset("nurse-chat.mp4");
      disc.appendChild(v);
      var p = v.play(); if (p && p.catch) p.catch(function () { /* the still stays */ });
    }, 800);
    // her cloud: 1.5 s after load for 9 s, again every 24 s, and when she is pointed at
    var cloudT = 0;
    var say = function (ms) { if (nurse.classList.contains("is-away")) return; cloud.classList.add("on"); clearTimeout(cloudT); cloudT = setTimeout(function () { cloud.classList.remove("on"); }, ms || 9000); };
    afterLoad(say, 1500);
    setInterval(function () { say(); }, 24000);
    nBtn.addEventListener("mouseenter", function () { say(4000); });

    var INBOX_HOSTS = "shopify-chat, shopify-agent-runtime, inbox-online-store-chat, #ShopifyChat";
    var INBOX_BUTTONS = ["button.activator", 'button[aria-controls="chat-ui"]', "button.chat-toggle"];
    var inboxBtn = null, looks = 0, watched = null, asked = false;
    var isOpen = function () { return !!inboxBtn && inboxBtn.getAttribute("aria-expanded") === "true"; };
    var aside = function (on) { nurse.classList.toggle("is-away", !!on); if (on) cloud.classList.remove("on"); };
    var findInbox = function (scope, depth) {
      scope = scope || document; depth = depth || 0;
      var hosts = scope.querySelectorAll(INBOX_HOSTS), found = null;
      for (var i = 0; i < hosts.length && !found; i++) {
        var sr = hosts[i].shadowRoot; if (!sr) continue;
        for (var j = 0; j < INBOX_BUTTONS.length && !found; j++) found = sr.querySelector(INBOX_BUTTONS[j]);
        if (!found && depth < 3) found = findInbox(sr, depth + 1);
      }
      return found;
    };
    // Shopify's button and its teaser go out of sight (the teaser box would still take clicks over her); its window
    // comes down to her corner
    var tame = function (b) {
      var where = b.getRootNode && b.getRootNode();
      if (!where || where === document || where.querySelector("style[data-wk-inbox]")) return;
      var st = document.createElement("style"); st.setAttribute("data-wk-inbox", "");
      st.textContent = INBOX_BUTTONS.join(",") + "{opacity:0!important;pointer-events:none!important}.activator-nudge{display:none!important}.desktop-layout .panel{bottom:20px!important}";
      where.appendChild(st);
    };
    // Shopify opens its window again by itself on the next page when it was open on the last one. Unless she was pressed
    // on this page, that window is shut again: the chat never opens on its own.
    var shutUnasked = function () { if (isOpen() && !asked) inboxBtn.click(); };
    var watch = function (b) {
      if (watched === b || !window.MutationObserver) return; watched = b;
      new MutationObserver(function () { if (isOpen() && !asked) { shutUnasked(); return; } aside(isOpen()); }).observe(b, { attributes: true, attributeFilter: ["aria-expanded"] });
      shutUnasked();
    };
    var lookForInbox = function () {
      var b = findInbox();
      if (b) { inboxBtn = b; tame(b); watch(b); nurse.setAttribute("data-inbox", ""); }
      else if (inboxBtn && !inboxBtn.isConnected) { inboxBtn = null; nurse.removeAttribute("data-inbox"); }
      setTimeout(lookForInbox, ++looks < 40 ? 500 : 4000);
    };
    // A press on her opens Shopify's window. Shopify shuts its window at any click outside it, her click included, so
    // its button is pressed a moment later; if the window is still shut after a second it is pressed once more.
    var openChat = function () {
      cloud.classList.remove("on");
      if (!inboxBtn || !inboxBtn.isConnected) { if (SHOP) location.href = "/pages/contact"; else say(4000); return; }
      asked = true;
      if (isOpen()) { aside(true); return; }
      var tries = 0;
      var press = function () { if (inboxBtn && inboxBtn.isConnected && tries < 2) { tries++; inboxBtn.click(); check(1000); } else if (SHOP) location.href = "/pages/contact"; };
      var check = function (left) { if (isOpen()) return; if (left > 0) { setTimeout(function () { check(left - 150); }, 150); return; } press(); };
      setTimeout(press, 60);
    };
    nBtn.addEventListener("click", openChat);
    cloud.addEventListener("click", openChat);
    lookForInbox();
  }
})();
